import { ComponentType } from 'react';

import { P } from '@/components/shared/Typography';

import { cn } from '../../../../../../../../lib/utils/cn';

interface I_BenefitItemProps {
  Icon: ComponentType<{ className?: string }>;
  title: string;
  description: string;
  className?: string;
}

export default function BenefitItem({
  Icon,
  title,
  description,
  className
}: I_BenefitItemProps) {
  return (
    <div
      className={cn(
        'card-border-gradient bg-[image:var(--card-gradient)] p-5 rounded-2xl flex flex-col gap-2.5',
        className
      )}
    >
      <P
        icon={<Icon className="w-9 h-9" />}
        className="font-bold text-lg items-center gap-1.5"
      >
        {title}
      </P>
      <P className="font-normal text-sm text-muted-foreground">{description}</P>
    </div>
  );
}
